import $ from 'jquery';
import resetForm from '../utils/reset-form';

export default function globalInquireForm() {
  const $form = $('.js-global-inquire-form');

  if (!$form.length) return;

  function setRegionCode() {
    const regionCode = $('#country-select option:selected').data('region-code');

    $('input[name="RegionCode"]').val(regionCode);
  }

  $('#country-select').on('change', function () {
    setRegionCode();

    $('.product-section').addClass('active');
  });

  const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  $form.find('[name="Handling"]').on('change', function () {
    $(this).closest('.js-global-inquire-form').find('.additional-fields').find('.group').removeClass('active');

    if (this.checked) {
      $(this).closest('.js-global-inquire-form').find('.additional-fields').find('.' + $(this).data('additional-field')).addClass('active');
    }
  });

  $form.find('[name=ContactType]').on('change', function (e) {
    $(this).parents('form').removeClass('hcp patient');

    if (e.target.value === 'Patient') {
      $(this).parents('form').addClass('patient');
    } else {
      $(this).parents('form').addClass('hcp');
    }
  });

  $form.find('[name=Source]').on('change', function (e) {
    if (e.target.value === 'conference') {
      $(this).parents('form').addClass('conf');
    } else {
      $(this).parents('form').removeClass('conf');
    }
  });

  $form.find('[name=GileadRepEmail]').on('input', function (e) {
    if (regexEmail.test(e.target.value)) {
      $('.requires-follow-up').addClass('required-value');
    } else if (e.target.value == '') {
      $('.requires-follow-up').removeClass('required-value');
      $form.find('[name=RequiresMIFollowUp][value=Yes]').prop('checked', true);
    }
  });

  $form.find('[name="Source"]').on('change', function () {
    const value = $(this).val();
    const gileadRepEmailValue = $('[name=GileadRepEmail]').val();

    if ( value.toLowerCase() === 'conference' && regexEmail.test(gileadRepEmailValue) ) {
      $('.requires-follow-up').addClass('required-value');
    } else {
      $('.requires-follow-up').removeClass('required-value');
    }
  });

  $form.on('submit', function (e) {
    e.preventDefault();

    if ( !$form.valid() ) return;

    $.post('/process/global_info_form.php', $form.serialize())
      .done(function() {
        console.log('complete');
        $('.js-form-container').addClass('complete');
      })
      .fail(function() {
        console.log('error');
        $('.js-form-container').addClass('error');
      });
  });

  $('.js-inquire-redo-btn').on('click', function() {
    $('.js-form-container').removeClass('complete');

    // Reset form
    const $form = $(this).closest('.js-form-container').find('.js-global-inquire-form');
    resetForm($form);
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/global-inquire-form.js